import { JSONAPINetworkCall } from 'utils/jsonapi/network';
import { APINetworkCall } from 'utils/network';

export const AuthLoginAPIRequest = data =>
  new APINetworkCall('auth', 'login', data);
export const AuthSignupAPIRequest = data =>
  new APINetworkCall('auth', 'register-user', data);
export const AuthRefreshTokenRequest = data =>
  new APINetworkCall('auth', 'refresh-token', data);
export const RequestPasswordResetAPIRequest = data =>
  new APINetworkCall('auth', 'request-password-reset', data);
export const FetchPasswordResetAPIRequest = data =>
  new APINetworkCall('auth', 'fetch-password-reset', data);
export const VerifyPasswordResetAPIRequest = data =>
  new APINetworkCall('auth', 'verify-password-reset', data);
export const FetchUserRoleAPIRequest = data =>
  new APINetworkCall('auth', 'fetch-user-role', data);

export const CreateVenueAPIRequest = data =>
  new APINetworkCall('venues', 'create-venue', data);
export const DefaultVenueAPIRequest = data =>
  new APINetworkCall('venues', 'default', data);
export const VenueDetailsAPIRequest = data =>
  new APINetworkCall('venues', 'get-details', data);
export const UpdateVenueAPIRequest = data =>
  new APINetworkCall('venues', 'update-venue', data);
export const QueryAuthorizedVenuesAPIRequest = data =>
  new APINetworkCall('venues', 'search-manageable', data);
export const FetchAuthorisedUsersAPIRequest = data =>
  new APINetworkCall('venues', 'get-authorised-users', data);
export const UploadVenueImageAPIRequest = data =>
  new APINetworkCall('venues', 'upload-image', data);
export const FetchManagedPagesAPIRequest = data =>
  new APINetworkCall('venues', 'get-managed-pages', data);
export const FetchVenueByParticipantIdAPIRequest = data =>
  new APINetworkCall('venues', 'get-details-by-participant-id', data);

export const IQOSAddLeadAPIRequest = data =>
  new APINetworkCall('iqos', 'add-lead', data);
export const IQOSFetchVenueLeadsAPIRequest = data =>
  new APINetworkCall('iqos', 'get-venue-leads', data);
export const IQOSFetchLeadsAPIRequest = data =>
  new APINetworkCall('iqos', 'get-leads', data);
export const IQOSUpdateLeadAPIRequest = data =>
  new APINetworkCall('iqos', 'update-lead', data);
export const IQOSSearchStaffAPIRequest = data =>
  new APINetworkCall('iqos', 'search-staff', data);

export const PayoutsAPIRequest = data =>
  new APINetworkCall('financial', 'get-payouts', data);
export const PayoutTransactionsAPIRequest = data =>
  new APINetworkCall('financial', 'get-payout-transactions', data);
export const UploadStripeDocumentAPIRequest = data =>
  new APINetworkCall('financial', 'upload-stripe-file', data);
export const FetchConnectedAccountDetailsAPIRequest = data =>
  new APINetworkCall('financial', 'get-connected-account', data);
export const UpdateFinancialDetailsAPIRequest = data =>
  new APINetworkCall('financial', 'update-financial-details', data);
export const ModifySourceAPIRequest = data =>
  new APINetworkCall('financial', 'modify-subscription-source', data);
export const FetchSubscriptionSourceAPIRequest = data =>
  new APINetworkCall('financial', 'get-subscription', data);
export const CreateConnectedAccountAPIRequest = data =>
  new APINetworkCall('financial', 'create-connected-account', data);
export const GetConnectedAccountAPIRequest = data =>
  new APINetworkCall('financial', 'get-connected-account', data);
export const CreateConnectedAccountLinkAPIRequest = data =>
  new APINetworkCall('financial', 'create-connected-account-link', data);

export const FetchAllMenusAPIRequest = (data, query) =>
  new APINetworkCall('menus', `fetch-menus${query}`, data);
export const SearchMenuItemsAPIRequest = data =>
  new APINetworkCall('menus', 'search-menu-item', data);
export const SetStockStatusAPIRequest = data =>
  new APINetworkCall('menus', 'set-stock-status', data);
export const GetOutOfStockAPIRequest = data =>
  new APINetworkCall('menus', 'get-out-of-stock', data);

export const FetchAllClientsAPIRequest = data =>
  new APINetworkCall('clients', 'list', data);
export const CreateClientAPIRequest = data =>
  new APINetworkCall('clients', 'create', data);
export const DeleteClientAPIRequest = data =>
  new APINetworkCall('clients', 'delete', data);
export const UpdateClientAPIRequest = data =>
  new APINetworkCall('clients', 'update', data);

export const GetBookingsAPIRequest = data =>
  new APINetworkCall('bookings', 'fetch-bookings', data);
export const FetchCompletedBookingsAPIRequest = data =>
  new APINetworkCall('bookings', 'fetch-completed-bookings', data);
export const FetchIQOSBookingsAPIRequest = data =>
  new APINetworkCall('bookings', 'fetch-iqos-bookings', data);
export const CreatePendingBookingAPIRequest = data =>
  new APINetworkCall('bookings', 'create-pending-booking', data);
export const EditBookingAPIRequest = data =>
  new APINetworkCall('bookings', 'update-booking', data);
export const EditLiveBookingAPIRequest = data =>
  new APINetworkCall('bookings', 'update-live-booking', data);
export const DeleteBookingAPIRequest = data =>
  new APINetworkCall('bookings', 'delete-booking', data);
export const RefundBookingAPIRequest = data =>
  new APINetworkCall('bookings', 'refund-booking', data);
export const GetPendingBookingsAPIRequest = data =>
  new APINetworkCall('bookings', 'get-pending-bookings', data);
export const SendBookingReminderAPIRequest = data =>
  new APINetworkCall('bookings', 'send-booking-reminder', data);
export const SearchBookingsAPIRequest = data =>
  new APINetworkCall('bookings', 'search-bookings', data);
export const PrintBookingAPIRequest = data =>
  new APINetworkCall('bookings', 'print-booking', data);
export const GetProductStatisticsAPIRequest = data =>
  new APINetworkCall('bookings', 'get-product-statistics', data);
export const GetSalesStatisticsAPIRequest = data =>
  new APINetworkCall('bookings', 'get-sales-statistics', data);

export const GetMenusAPIRequest = data =>
  new APINetworkCall('menus', 'fetch-menus', data);
export const GetAllMenusAPIRequest = data =>
  new APINetworkCall('menus', 'fetch-menus?include_draft', data);
export const GetMenuAPIRequest = data =>
  new APINetworkCall('menus', 'fetch-menu', data);
export const UpdateMenuAPIRequest = data =>
  new APINetworkCall('menus', 'update-menu', data);
export const UpdateMenuOperationsAPIRequest = data =>
  new APINetworkCall('menus', 'menu-operations', data);

export const TrackEventAPIRequest = data =>
  new APINetworkCall('analytics', 'track-event', data);
export const FetchAnalyticsAPIRequest = data =>
  new APINetworkCall('analytics', 'fetch-analytics', data);

// Reservations

export const FetchReservationsAPIRequest = data =>
  new APINetworkCall('bookings', 'fetch-reservations', data);
export const FetchBookingByReservationShortCodeAPIRequest = data =>
  new APINetworkCall(
    'bookings',
    'fetch-booking-by-reservation-shortcode',
    data
  );

export const CreateReservationAPIRequest = data =>
  new APINetworkCall('bookings', 'create-reservation', data);
export const DeleteReservationAPIRequest = data =>
  new APINetworkCall('bookings', 'delete-reservation', data);
export const UpdateReservationAPIRequest = data =>
  new APINetworkCall('bookings', 'update-reservation', data);

export const CreateUserAPIRequest = data =>
  new APINetworkCall('auth', 'create-user', data);
export const FetchACLUsersAPIRequest = data =>
  new APINetworkCall('auth', 'fetch-acl-users', data);
export const UpdateACLUserAPIRequest = data =>
  new APINetworkCall('auth', 'update-acl-user', data);
export const DeleteACLUserAPIRequest = data =>
  new APINetworkCall('auth', 'delete-acl-user', data);

// Labels API
export const FetchLabelRequest = data =>
  new APINetworkCall('menus/labels', 'fetch', data);
export const FetchLabelsRequest = data =>
  new APINetworkCall('menus/labels', 'list', data);
export const CreateLabelRequest = data =>
  new APINetworkCall('menus/labels', 'create', data);
export const UpdateLabelRequest = data =>
  new APINetworkCall('menus/labels', 'update', data);
export const DeleteLabelRequest = data =>
  new APINetworkCall('menus/labels', 'delete', data);

// Fatsoma API
export const CreateRegistrationFatsomaAPIRequest = data =>
  new JSONAPINetworkCall('POST', 'basic-registrations', data);
export const FetchPageFatsomaAPIRequest = data =>
  new JSONAPINetworkCall('GET', `pages/${data.id}`);

// Groups - Multivenue
export const FetchAllGroupsAPIRequest = data =>
  new APINetworkCall('groups', 'list', data);
export const CreateGroupAPIRequest = data =>
  new APINetworkCall('groups', 'create', data);
export const DeleteGroupsAPIRequest = data =>
  new APINetworkCall('groups', 'delete', data);
export const UpdateGroupsAPIRequest = data =>
  new APINetworkCall('groups', 'update', data);

// Option Groups
export const FetchAllOptionGroupsAPIRequest = data =>
  new APINetworkCall('menus', 'list-option-groups', data);
export const FetchOptionGroupAPIRequest = data =>
  new APINetworkCall('menus', 'get-option-group', data);
export const CreateOptionGroupAPIRequest = data =>
  new APINetworkCall('menus', 'create-option-group', data);
export const DeleteOptionGroupsAPIRequest = data =>
  new APINetworkCall('menus', 'delete-option-group', data);
export const UpdateOptionGroupsAPIRequest = data =>
  new APINetworkCall('menus', 'update-option-group', data);



// WEBPACK FOOTER //
// ./src/utils/constants/network.js